import {IconButton} from '@wandb/components';
import React, {useCallback} from 'react';

import {useIsInLoadedReportContext} from '../../pages/ReportPage/LoadedReportContext';
import type * as PanelTypes from '../../state/views/panel/types';
import type * as PanelBankSectionConfigTypes from '../../state/views/panelBankSectionConfig/types';
import {type PanelType} from '../../util/panelTypes';
import {useWorkspaceDrawerContext} from '../WorkspaceDrawer/WorkspaceDrawerContextProvider';

/**
 * This is soon to be deprecated when we have a ReportPanelHeader created.
 */
export const PanelRunMetricButton = ({
  panelBankSectionConfigRef,
  panelRef,
  panelType,
}: {
  /**
   * Run metric button can only appear in a workspace and not reports.
   * TODO: Improve type so panelBankSectionConfigRef cannot be undefined because
   * that implies we are also using this in report panels.
   */
  panelBankSectionConfigRef: PanelBankSectionConfigTypes.Ref | undefined;
  panelRef: PanelTypes.Ref;
  panelType: PanelType;
}) => {
  const isInReport = useIsInLoadedReportContext();

  if (panelType !== 'Run History Line Plot' || isInReport) {
    return null;
  }

  return (
    <WorkspacePanelRunMetricButton
      panelBankSectionConfigRef={panelBankSectionConfigRef}
      panelRef={panelRef}
    />
  );
};
const RunMetricButton = ({
  buttonSize,
  onClick,
}: {
  buttonSize: 'sm' | 'md';
  onClick: () => void;
}) => {
  return (
    <IconButton
      icon="bell-notifications"
      variant="ghost"
      aria-label="Create alert automation"
      data-dd-action-name="Create alert automation"
      size={buttonSize}
      tooltip={{children: 'Create alert automation'}}
      onPress={e => {
        e.continuePropagation();
        onClick();
      }}
    />
  );
};

/**
 * This can be consolidated with the WorkspacePanelRunMetricButton once we
 * have a ReporPanelHeader to work with.
 */
export const FullScreenPanelRunMetricButton = ({
  panelBankSectionConfigRef,
  panelRef,
  panelType,
}: {
  panelBankSectionConfigRef: PanelBankSectionConfigTypes.Ref;
  panelRef: PanelTypes.Ref;
  panelType: PanelType;
}) => {
  const {openWorkspaceDrawer} = useWorkspaceDrawerContext();

  const onClick = useCallback(() => {
    openWorkspaceDrawer('create-trigger', panelBankSectionConfigRef, panelRef);
  }, [openWorkspaceDrawer, panelBankSectionConfigRef, panelRef]);

  if (panelType !== 'Run History Line Plot') {
    return null;
  }

  return <RunMetricButton buttonSize="md" onClick={onClick} />;
};

const WorkspacePanelRunMetricButton = ({
  panelBankSectionConfigRef,
  panelRef,
}: {
  panelBankSectionConfigRef: PanelBankSectionConfigTypes.Ref | undefined;
  panelRef: PanelTypes.Ref;
}) => {
  const {openWorkspaceDrawer} = useWorkspaceDrawerContext();

  const onClick = useCallback(() => {
    openWorkspaceDrawer('create-trigger', panelBankSectionConfigRef, panelRef);
  }, [openWorkspaceDrawer, panelBankSectionConfigRef, panelRef]);

  return <RunMetricButton buttonSize="sm" onClick={onClick} />;
};
